import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import {  } from '../actions/api'
import { formatDateHistory, formatDateForCalendar, fromSeconds } from '../actions/helpers';
import { setCurrentUserState, setUserSelectedSnapshotIndex } from '../actions/localStates'

class UserHistoryView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	current_period: "seconds",
			displayed_value: 0
	    }

	    this.setShowSnapshotList = this.setShowSnapshotList.bind(this);
	    this.closeSnapshotList = this.closeSnapshotList.bind(this);

	    this.onSnapshotDateChanged = this.onSnapshotDateChanged.bind(this);
	    this.getPreviousSnapshot = this.getPreviousSnapshot.bind(this);
	    this.getNextSnapshot = this.getNextSnapshot.bind(this);
	    this.getFirstSnapshot = this.getFirstSnapshot.bind(this);

	    this.checkIfPasswordChanged = this.checkIfPasswordChanged.bind(this);
	}

	onSnapshotDateChanged (index) {
		var _this = this;
		var enquire = JSON.parse(_this.props.userHistory.snapshotList[index].userJson)
        _this.props.actions.setCurrentUserState(enquire)
		this.props.actions.setUserSelectedSnapshotIndex(index)
		this.setState({"modifyingDateTime": _this.props.userHistory.snapshotList[index].modifyingDateTime})
		this.setState({"modifyingInitiatorId": _this.props.userHistory.snapshotList[index].modifyingInitiatorId})
		
        this.setState({"snapshotDate": _this.props.userHistory.snapshotList[index].modifyingDateTime})
    }

    checkIfPasswordChanged () {
    	if (this.props.userHistory.selectedSnapshotIndex + 1 > this.props.userHistory.snapshotList.length - 1) {
    		return false;
    	}

    	var prevEnquire = JSON.parse(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex + 1].userJson)

    	if (this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.password === prevEnquire.password) {
    		return false;
    	} else {
    		return true;
    	}
    	
    }

    getPreviousSnapshot () {
		var _this = this;
		var enquire, prevDate;
		if ((this.props.userHistory.selectedSnapshotIndex + 1) < this.props.userHistory.snapshotList.length) {
			enquire = JSON.parse(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex + 1].userJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentUserState(enquire)
            }, 25)
			this.props.actions.setUserSelectedSnapshotIndex(this.props.userHistory.selectedSnapshotIndex + 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex + 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex + 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex + 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		} else {
			enquire = JSON.parse(this.props.userHistory.snapshotList[this.props.userHistory.snapshotList.length - 1].userJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentUserState(enquire)
            }, 25)
			this.props.actions.setUserSelectedSnapshotIndex(this.props.userHistory.snapshotList.length - 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.userHistory.snapshotList[this.props.userHistory.snapshotList.length - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.userHistory.snapshotList[this.props.userHistory.snapshotList.length - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.userHistory.snapshotList[this.props.userHistory.snapshotList.length - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		}

		this.setState({"snapshotDate": prevDate})
	}
	
	getNextSnapshot () {
		var _this = this;
		var enquire, nextDate;
		if ((this.props.userHistory.selectedSnapshotIndex - 1) <= 0) {
			enquire = JSON.parse(this.props.userHistory.snapshotList[0].userJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentUserState(enquire)
            }, 25)
			
			this.props.actions.setUserSelectedSnapshotIndex(0)
			nextDate = this.props.actions.formatDateForCalendar(this.props.userHistory.snapshotList[0].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.userHistory.snapshotList[0].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.userHistory.snapshotList[0].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		} else {
			enquire = JSON.parse(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex - 1].userJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentUserState(enquire)
            }, 25)
			this.props.actions.setUserSelectedSnapshotIndex(this.props.userHistory.selectedSnapshotIndex - 1)
			nextDate = this.props.actions.formatDateForCalendar(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		}

		this.setState({"snapshotDate": nextDate})
	}

	getFirstSnapshot () {
		var _this = this;
		var enquire = JSON.parse(this.props.userHistory.snapshotList[0].userJson)

		window.setTimeout(function () {
        	_this.props.actions.setCurrentUserState(enquire)
        }, 25)
		this.props.actions.setUserSelectedSnapshotIndex(0)
	}

	componentDidMount() {
		var _this = this;
		if (this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.tokenExpiredAfterSec > 0) {
			window.setTimeout(function () {
				var curr_date = _this.props.actions.fromSeconds(_this.props.userHistory.currentUserState.tokenExpiredAfterSec)
				_this.setState({"displayed_value": curr_date.value})
				_this.setState({"current_period": curr_date.unit})
			}, 25)
		}
	}

	componentDidUpdate(prevProps) {
		var _this = this;
		if (prevProps.userHistory !== this.props.userHistory && this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.tokenExpiredAfterSec > 0) {
			var curr_date = _this.props.actions.fromSeconds(_this.props.userHistory.currentUserState.tokenExpiredAfterSec)
			_this.setState({"displayed_value": curr_date.value})
			_this.setState({"current_period": curr_date.unit})
		}
    }

	componentWillUnmount() {

	}

	setShowSnapshotList (event) {
		event.preventDefault();
		this.setState({
				showSnapshotList: !this.state.showSnapshotList
			}, () => {
			document.addEventListener('click', this.closeSnapshotList);
		});
  	}

	closeSnapshotList(event) { 
		this.setState({ showSnapshotList: false }, () => {
			document.removeEventListener('click', this.closeSnapshotList);
		});  
	}

	render() {
		let showSnapshotListOpen = 'dropdown-menu'
	    if (this.state.showSnapshotList) {
	      showSnapshotListOpen = 'dropdown-menu show'
	    }

	    let activeClass  = this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.confirmedProfile !== null ? 'edit-view-history' : "edit-view-history-single"
		if (this.props.base.drawerOpen) {
			activeClass = this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.confirmedProfile !== null ? 'edit-view-history open' : "edit-view-history-single open"
		}
		return (
			<div className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>
				{
					this.props.userHistory.snapshotList.length > 0
					? <div style={{float: "right", marginLeft: "auto"}}>
						<div className="row no-right-padding">
							<div className="dropdown" style={{paddingLeft: "0px", paddingRight: "10px"}}>
                                <button className="btn btn-outline-info" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" onClick={this.setShowSnapshotList}>
                                    <label className="text-overflow-label" style={{marginBottom: "0px"}}>{i18next.t("version")}{this.props.userHistory.snapshotList.length - this.props.userHistory.selectedSnapshotIndex}<span className="paddingLeft10">{i18next.t("dateTime")}</span>{this.props.actions.formatDateHistory(this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex] !== undefined ? this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex].modifyingDateTime : null)}<span className="paddingLeft10">{i18next.t("issuerLabel")}</span>{this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex] !== undefined ? this.props.userHistory.snapshotList[this.props.userHistory.selectedSnapshotIndex].modifyingInitiatorId : ""}</label>
                                </button>
                                <div className={showSnapshotListOpen} style={{width: "100%", overflowY: "auto", maxHeight: "500px", fontSize: "14px"}}>
                                    {
                                        <table className="table table-striped" style={{marginBottom: "0px"}}>
										  <tbody>
										    {this.props.userHistory.snapshotList.map((snapshot, index) => (
										      <tr key={index} className="cursor-pointer" onClick={this.onSnapshotDateChanged.bind(this, index)}>
										        <td style={{paddingLeft: "5px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("version")}</span>{(this.props.userHistory.snapshotList.length - index)}</td>
										        <td style={{paddingLeft: "20px"}}><span style={{fontWeight: "700"}}>{i18next.t("dateTime")}</span>{this.props.actions.formatDateHistory(snapshot.modifyingDateTime)}</td>
										        <td style={{paddingLeft: "0px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("issuerLabel")}</span>{snapshot.modifyingInitiatorId}</td>
										      </tr>
										    ))}
										  </tbody>
										</table>
                                    }
                                </div>
                            </div>

							<button className="btn btn-outline-info" title={i18next.t("actual")} style={{marginRight: "5px"}} disabled={this.props.userHistory.selectedSnapshotIndex === 0 ? true : false} onClick={this.getFirstSnapshot}>{"|<"}</button>
	                        <button className="btn btn-outline-info" title={i18next.t("next")} style={{marginRight: "5px"}} disabled={this.props.userHistory.selectedSnapshotIndex === 0 ? true : false} onClick={this.getNextSnapshot}>{"<"}</button>
	                        <button className="btn btn-outline-info" title={i18next.t("previous")} style={{marginRight: "5px"}} disabled={this.props.userHistory.selectedSnapshotIndex === this.props.userHistory.snapshotList.length - 1 ? true : false} onClick={this.getPreviousSnapshot}>{">"}</button>

	                    </div>
	                </div>
					: null
				}
				{
					this.props.userHistory.snapshotList.length > 0
					? <div className={activeClass}>
						<div className="col-10">
							<div className="row col-12 equal-height-row">
								<div className="col-6 equal-height-col" style={{paddingLeft: "0px"}}>
									<label className="section-label">{i18next.t("formLabel")}</label>
									<div className="border-for-history equal-height-content">
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("uniqueIdLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.userName : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("userStatusLabel") + ": "}<span style={{color: "black"}}>{i18next.t(this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.status : "")}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("surnameLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.secondName : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("nameLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.firstName : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("departmentLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.department : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("positionLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.position : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("emailLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.email : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("phoneLabel") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.phone : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("advancedInfo") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.extendedData : ""}</span></label>
										
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("activeTokensNumberTitle") + ": "}<span style={{color: "black"}}>{this.props.userHistory.currentUserState !== null ? this.props.userHistory.currentUserState.activeTokenNumber : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("tokensExpiredAfterTitle") + ": "}<span style={{color: "black"}}>{this.state.displayed_value + " " + i18next.t(this.state.current_period)}</span></label>
										{
											this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.twoFactorChannelId !== null && this.props.userHistory.currentUserState.twoFactorChannelId.length > 0
											? <div>
												<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("titleFor2F") + ": "}<span style={{color: "black", wordBreak: "break-all"}}>{this.props.userHistory.currentUserState !== null
													? (() => {
															const { twoFactorChannelId, twoFactorSettings } = this.props.userHistory.currentUserState;
															const secretKey = twoFactorSettings?.secretKey || "";
															let maskedKey = secretKey;

															if (secretKey.length > 10) {
																maskedKey =
																	secretKey.slice(0, 5) +
																	"*".repeat(secretKey.length - 10) +
																	secretKey.slice(-5);
															}

															return `${twoFactorChannelId}, ${maskedKey}`;
													  })()
													: ""}</span></label>
											  </div>
											: null
										}
										<label
											className="col-12 col-form-label"
											style={{ fontSize: "15px", color: "#b5b1af", paddingBottom: "0px" }}
										>
											{i18next.t("rolesLabel") + ": "}
											<span style={{color: "black"}}>
												{
													this.props.userHistory.currentUserState !== null &&
													this.props.userHistory.currentUserState.roles.length > 0 && (
																this.props.userHistory.currentUserState.roles
																.map((role) => i18next.t(role))
																.join(", ")
												)}
											</span>
										</label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "10px"}}>
											{i18next.t("passwordChanged") + ": "}
											<span style={{ color: "black" }}>{
												this.checkIfPasswordChanged() ? i18next.t("yes") : i18next.t("no")
											}</span>
										</label>
									</div>
								</div>

								{
									this.props.userHistory.currentUserState !== null && this.props.userHistory.currentUserState.confirmedProfile !== null
									? <div className="col-6 equal-height-col" style={{ paddingLeft: "0px" }}>
										<label className="section-label">
											{i18next.t("profileLabel")}
										</label>
										<div className="border-for-history equal-height-content">
											{Object.entries(this.props.userHistory.currentUserState.confirmedProfile)
												.filter(([key, value]) => value !== null && value !== undefined && String(value).trim() !== "")
												.sort(([keyA], [keyB]) => keyA.localeCompare(keyB, undefined, { sensitivity: "base" }))
												.map(([key, value], index, array) => (
													<label
														key={key}
														className="col-12 col-form-label"
														style={{
															fontSize: "15px",
															color: "#b5b1af",
															paddingBottom: index === array.length - 1 ? "10px" : "0px"
														}}
													>
														{i18next.t(key) + ": "}
														<span style={{ color: "black" }}>{value}</span>
													</label>
												))}
										</div>
									</div>
									: null
								}
							</div>
						</div>
					  </div>
					: <div style={{textAlign: "center"}}>
						<label>{i18next.t("noHistory")}</label>
					  </div>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        tokens: state.tokensReducer,
        login: state.loginReducer,
        user: state.userReducer,
        userHistory: state.userHistoryReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	formatDateHistory, formatDateForCalendar, setCurrentUserState,
    	setUserSelectedSnapshotIndex, fromSeconds
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserHistoryView);